import { NewYearSparkles } from "./NewYearSparkles";
import { ChristmasSnowflakes } from "./ChristmasSnowflakes";
import { EasterConfetti } from "./EasterConfetti";
import { HalloweenSpooky } from "./HalloweenSpooky";

interface EffectRendererProps {
  effect: string | null;
  className?: string;
}

// Map effect names to their corresponding components
const EFFECT_MAP: Record<string, React.ComponentType> = {
  "new-year-sparkles": NewYearSparkles,
  "christmas-snowflakes": ChristmasSnowflakes,
  "easter-confetti": EasterConfetti,
  "halloween-spooky": HalloweenSpooky,
};

/**
 * EffectRenderer
 *
 * Central component that renders the appropriate animation effect based on the
 * effect string value from the database.
 *
 * @param effect - Effect name from database (e.g., 'new-year-sparkles')
 * @param className - Optional className for wrapper
 * @returns The corresponding effect component or null
 */
export const EffectRenderer: React.FC<EffectRendererProps> = ({
  effect,
  className = "",
}) => {
  // Return null if no effect specified or if effect is 'none'
  if (!effect || effect === "none") {
    return null;
  }

  // Get the corresponding effect component
  const EffectComponent = EFFECT_MAP[effect];

  // Return null if effect name doesn't match any known effects
  if (!EffectComponent) {
    console.warn(`Unknown effect: ${effect}`);
    return null;
  }

  // Render the effect component
  return (
    <div className={className}>
      <EffectComponent />
    </div>
  );
};
